import { memo, type JSX } from 'react';
import type { DocumentEntity } from '@/context/store/slices/documentDataSlice';
import {
  DocumentViewContainer,
  DocumentViewImage,
  DocumentViewList,
  DocumentViewTable,
  DocumentViewText,
} from '@/components/document';

function DocumentViewBlockComponent({
  node,
  childNodes,
  depth = 0,
  parentStyle = null,
}: {
  node: DocumentEntity;
  childNodes?: JSX.Element[];
  depth?: number;
  parentStyle?: string | null;
}) {
  switch (node.type) {
    case 'container':
      return (
        <DocumentViewContainer
          node={node}
          childNodes={childNodes}
          depth={depth}
          parentStyle={parentStyle}
        />
      );

    case 'text':
      return <DocumentViewText node={node} depth={depth} />;

    case 'table':
      return <DocumentViewTable node={node} />;

    case 'image':
      return <DocumentViewImage node={node} />;

    case 'list':
      return <DocumentViewList node={node} />;

    default:
      return (
        <div>
          Unsupported block type: {(node as { type: string }).type}
        </div>
      );
  }
}

const DocumentViewBlock = memo(DocumentViewBlockComponent);

export { DocumentViewBlock };
